var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClubeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.017 38.907L33.44 9.88602C33.413 9.57742 33.2715 9.2901 33.0433 9.0806C32.8151 8.8711 32.5168 8.75459 32.207 8.75402H26.9C26.8572 6.42413 25.9016 4.20413 24.2388 2.57157C22.576 0.939012 20.3388 0.024353 18.0085 0.024353C15.6782 0.024353 13.441 0.939012 11.7782 2.57157C10.1154 4.20413 9.1598 6.42413 9.117 8.75402H3.817C3.50683 8.75321 3.20772 8.86924 2.97923 9.07901C2.75075 9.28878 2.60964 9.57691 2.584 9.88602L0.00899887 38.907C0.00899887 38.944 0 38.981 0 39.017C0 42.317 3.028 45.009 6.756 45.009H29.27C32.998 45.009 36.026 42.321 36.026 39.017C36.0275 38.9801 36.0245 38.9432 36.017 38.907ZM18.017 2.48502C19.6913 2.48721 21.2983 3.14408 22.4947 4.31529C23.6912 5.4865 24.3821 7.07917 24.42 8.75302H11.607C11.6449 7.07866 12.3362 5.48554 13.5333 4.31424C14.7304 3.14295 16.3382 2.48642 18.013 2.48502H18.017ZM29.27 42.525H6.756C4.418 42.525 2.522 40.979 2.485 39.073L4.952 11.248H9.112V15.022C9.12118 15.3455 9.25611 15.6526 9.48812 15.8781C9.72013 16.1036 10.0309 16.2298 10.3545 16.2298C10.6781 16.2298 10.9889 16.1036 11.2209 15.8781C11.4529 15.6526 11.5878 15.3455 11.597 15.022V11.248H24.42V15.022C24.4292 15.3455 24.5641 15.6526 24.7961 15.8781C25.0281 16.1036 25.3389 16.2298 25.6625 16.2298C25.9861 16.2298 26.2969 16.1036 26.5289 15.8781C26.7609 15.6526 26.8958 15.3455 26.905 15.022V11.248H31.065L33.541 39.073C33.5 40.978 31.6 42.525 29.27 42.525Z",
    fill: "#000FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.026,
    height: 45.01,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClubeSelected);
export default __webpack_public_path__ + "static/media/ic_clube_selected.69d57e9037d726f3a1e6ebc2c77be9c6.svg";
export { ForwardRef as ReactComponent };